import { useCallback } from 'react';

import { useEventsInfoWithFilteredPlayersQuery } from '@/api/events/query.generated';
import { useEventPlayerIds } from '@/feature/entries-pickem/hooks/use-event-player-ids';
import { useResumeEffectWithDelay } from '@/hooks/use-resume';

import { useBetslipStore } from './use-betslip-store';
import { useLiveEventsPropsUpdate } from './use-live-props-update';

export const useBetslipPlayersFetch = () => {
    const betslip = useBetslipStore(state => state.betslip);
    const { eventIds, playerIds } = useEventPlayerIds(betslip);

    const [{ data }, fetchEventsWithFilteredPlayers] = useEventsInfoWithFilteredPlayersQuery({
        variables: {
            eventIds,
            playerIds,
        },
        requestPolicy: 'network-only',
        pause: true,
    });

    useResumeEffectWithDelay(
        useCallback(() => {
            fetchEventsWithFilteredPlayers();
        }, [fetchEventsWithFilteredPlayers]),
        100
    );

    useLiveEventsPropsUpdate({
        events: data?.getEventsWithFilteredPlayers,
        options: {
            subscribeToGameClockUpdates: true,
            subscribeToMarketUpdates: true,
            debugTag: 'PlayersPicksListModal',
        },
    });

    return {
        events: data?.getEventsWithFilteredPlayers,
        //Only consider loading, while initial data loads, and not on subsequent fetches
        loading: data?.getEventsWithFilteredPlayers === undefined,
    };
};
